<template>
  <v-card>
    <v-container>
      <v-row class="pt-5">
        <v-col cols=2>
        </v-col>
        <v-col cols=8>
          <v-alert type="error" v-if="displayError && disabledMessage">{{ disabledMessage }}</v-alert>
          <v-alert type="error" v-else-if="displayError">Sorry, your credentials are incorrect. Please check your email and
            password, and ty
            again.</v-alert>
          <v-text-field v-model="email" label="Email" @keyup.enter="login"></v-text-field>
          <v-text-field v-model="password" label="Password" type="password" @keyup.enter="login"></v-text-field>
        </v-col>
        <v-col cols=2></v-col>
      </v-row>
      <v-row class="pb-5">
        <v-col cols=2></v-col>
        <v-col cols=8>
          <v-btn :disabled="disabled" color="primary" @click="login">Login</v-btn>
        </v-col>
        <v-col cols=2></v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import Vue from 'vue'
// import { pick } from 'lodash'

export default {
  name: 'LoginContainer',
  props: [],
  data: () => ({
    email: null,
    password: null,
    displayError: false,
    disabledMessage: null,
    loading: false
  }),
  computed: {
    credentials: function () {
      return {
        user: {
          email: this.email,
          password: this.password
        }
      }
    },
    disabled: function () {
      return !(this.email && this.password) && !this.loading
    }
  },
  mounted() {
    // Check for autofilled values after component mounts
    this.$nextTick(() => {
      this.checkAutofill()
    })
    
    // Listen for autofill events
    this.$el.addEventListener('input', this.checkAutofill)
    this.$el.addEventListener('change', this.checkAutofill)
  },
  beforeDestroy() {
    // Clean up event listeners
    this.$el.removeEventListener('input', this.checkAutofill)
    this.$el.removeEventListener('change', this.checkAutofill)
  },
  methods: {
    checkAutofill() {
      // Get the input elements
      const emailInput = this.$el.querySelector('input[type="text"], input[type="email"]')
      const passwordInput = this.$el.querySelector('input[type="password"]')
      
      // Update Vue data if inputs have values but Vue data is null
      if (emailInput && emailInput.value && !this.email) {
        this.email = emailInput.value
      }
      if (passwordInput && passwordInput.value && !this.password) {
        this.password = passwordInput.value
      }
    },
    async login() {
      if (this.disabled) {
        return
      }

      try {
        this.displayError = false
        this.loading = true
        const response = await Vue.axios.post(process.env.VUE_APP_API_HOST + '/login', {
          user: {
            email: this.email,
            password: this.password,
          }
        })

        const session = {
          user: response.data,
          authorization: response.headers.authorization
        }

        this.$emit('login', session)
      } catch (e) {
        // A disabled user or account gets its own message from the API
        const error = e.response && e.response.data && e.response.data.error
        this.disabledMessage = error && error.includes('disabled') ? error : null
        this.displayError = true
      }
    }
  }
}
</script>
